<template>
  <div v-if="this.type == 'aircon'">
    <Aircon
      v-if="this.calldata[0]"
      :calldata="this.calldata"
      :type="this.type"
      :sensorid="this.sensorid"
    />
  </div>
  <div v-else-if="this.type == 'relay'">
    <Relay :type="this.type" />
  </div>
  <div id="myDiv" v-else>
    <vs-breadcrumb v-if="this.username == 'betagrodemo' || admin == 'betagrodemo'">
      <li>
        <a aria-current="page" style="color: #ffffff" title="Device Management"
          >Device Management</a
        ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'IndoorSensor'" style="color: #ffffff" title="Device"
          >Sensor</router-link
        ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Sensor</li>
    </vs-breadcrumb>
    <vs-breadcrumb v-else>
      <li>
        <a
          aria-current="page"
          style="color: rgba(0, 0, 0, 0.4)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'IndoorSensor'" title="Device">Sensor</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Sensor</li>
    </vs-breadcrumb>
    <vs-row vs-w="12" v-if="this.username != 'poonsak.ngk'">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <vs-row class="mt-2" slot="header">
            <h4>
              {{ sensorname }}
            </h4>
            <vs-spacer />
            <!-- v-b-modal.Calibrate -->
            <vs-button
              v-if="this.username === 'Rivacold01'"
              class="btnBorderpop"
              @click="get_calibrate(get_cari[0].id)"
              color="warning"
              type="filled"
              >Calibration</vs-button
            >
          </vs-row>
          <vs-row vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              class="p-3"
              vs-sm="4"
              vs-xs="4"
            >
              <img
                v-if="type == 'S1'"
                src="../../../assets/images/sensor/tempsensor.png"
                width="190"
                height="100"
              />
              <img
                v-if="type == 'S4'"
                src="../../../assets/images/sensor/doorsensor.png"
                width="150"
                height="100"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-align="center"
              vs-lg="7"
              vs-sm="7"
              vs-xs="8"
            >
              <div style="width: 100%">
                <vs-row vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <!-- <vs-icon color="green" class icon="edit" size="12px" ></vs-icon> -->

                    <span class="font-weight-bold">Name</span>

                    <v-icon aria-hidden="false"> </v-icon>

                    <b-modal
                      id="addsensor"
                      :no-close-on-backdrop="false"
                      hide-header-close
                      centered
                      hide-footer
                      size="lg"
                    >
                      <template #modal-title>
                        <h4 class="textSuccess">Edit Device</h4>
                      </template>
                      <div>
                        <AddDevice
                          :mac="this.macname"
                          :typed="this.type"
                          :sensorname="this.sensorname"
                        />
                      </div>
                    </b-modal>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span class="mr-2">{{ sensorname }}</span>
                    <!-- --------------------------------- ICON ------------------------- -->

                    <vs-icon
                    v-if="this.username == admin"
                      icon="edit"
                      color="primary"
                      size="18px"
                      v-b-modal.addsensor
                    ></vs-icon>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold textNowrap">Mac Address</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ macname }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Type</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ type }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <!-- <span class="font-weight-bold">Type</span> -->
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8"> </vs-col>
                </vs-row>
                <b-modal
                  id="Calibrate"
                  ref="modalCali"
                  centered
                  title="Calibration"
                  no-close-on-backdrop="false"
                  hide-header-close
                >
                  <!-- <pre>{{ get_cali }}</pre> -->
                  <vs-row>
                    <vs-col vs-type="flex" vs-align="center" vs-w="2">
                      Temperature
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="3"
                    >
                      {{ get_cali.temp }}°C
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="3"
                    >
                      <vs-input-number
                        min="-40"
                        v-model="tempCalibrate"
                      />
                      <!-- <vs-input class="inputx" v-model="tempCalibrate" /> -->
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="3"
                    >
                      <b class="textSuccess"> {{ calibrationTemp }}°C</b>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-type="flex" vs-align="center" vs-w="2">
                      Humidity
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="3"
                    >
                      {{ get_cali.humid }} %
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="3"
                    >
                      <!-- <vs-input class="inputx" v-model="humidCalibrate" /> -->
                      <vs-input-number
                        min="-40"
                        v-model="humidCalibrate"
                      />
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="3"
                    >
                      <b class="textSuccess">{{ calibrationhumid }}%</b>
                    </vs-col>
                  </vs-row>
                  <template #modal-footer="{}">
                    <vs-button
                      class="btnBorderpop"
                      size="small"
                      color="success"
                      type="filled"
                      @click="
                        acceptCalibrate(
                          tempCalibrate,
                          humidCalibrate,
                          get_cari[0].id
                        )
                      "
                      >Submit</vs-button
                    >
                    <vs-button
                      size="small btnBorderpop"
                      color="dark"
                      type="flat"
                      @click="cancelModal()"
                      >Cancel</vs-button
                    >
                    <!-- Button with custom close trigger value -->
                    <!-- <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="cancel()"
                    >
                      Cancel
                    </b-button> -->
                  </template>
                </b-modal>
                <!-- <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Location</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ nwname }}</span>
                  </vs-col>
                </vs-row> -->
                <vs-row class="mt-3" vs-w="12">
                  <!-- <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Status</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ lastact }}</span>
                  </vs-col> -->
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- <vs-card >
      <h4 class="card-title d-flex">Control Status</h4>
    </vs-card>

    <vs-row v-if="this.type == 'control'">
      <Control
        v-if="this.calldata[0]"
        :id="this.sensorid"
        :gid="this.gatewayid"
        :nwid="this.nwid"
        :nwname="this.nwname"
        :type="this.type"
      />
    </vs-row> -->

    <!-- <vs-button type="filled" icon="keyboard_backspace" color="#333f50" @click="back()">Back</vs-button> -->

    <!-- <vs-col vs-lg="6" vs-xs="12">
      <AlertState v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
    </vs-col> -->
    <vs-col vs-lg="12" vs-xs="12">
      <Lastest
        v-if="this.calldata[0]"
        :id="this.sensorid"
        :calldata="this.calldata"
        :nwid="this.nwid"
        :nwname="this.nwname"
        :type="this.type"
      />
    </vs-col>
    <!-- <pre style="background: #FFFFFF;">{{this.resultLogSensor}}</pre> -->
    <vs-row vs-w="12">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <vs-row id="center">
            <vs-list-header
              title="Tag Data History"
              style="font-size: 18px"
              color="dark"
            ></vs-list-header>
            <vs-spacer />
            <vs-button
              radius
              class="mr-2"
              color="success"
              type="flat"
              @click="exportXLSX"
              icon="cloud_download"
              align="right"
            ></vs-button>
          </vs-row>

          <vs-tabs v-if="this.username != 'poonsak.ngk'">
            <vs-tab label="History Logs Chart">
              <div class="con-tab-ejemplo mt-4" ref="pdf">
                <vs-row>
                  <vs-col class="mt-2" vs-lg="3" vs-xs="12">
                    <p>Select Start Date</p>
                    <!-- <datetime v-model="mintime" format="YYYY/MM/DD H:i:s" bootstrap-styling = "true" /> -->
                    <datetime
                      v-model="mintime"
                      type="datetime"
                      input-class="form-control"
                      placeholder="YYYY/MM/DD H:i:s"
                    ></datetime>
                  </vs-col>
                  <vs-col class="mt-2" vs-lg="3" vs-xs="12">
                    <p>Select End Date</p>
                    <!-- <datetime v-model="maxtime" format="YYYY/MM/DD H:i:s"/> -->
                    <datetime
                      v-model="maxtime"
                      type="datetime"
                      input-class="form-control"
                      placeholder="YYYY/MM/DD H:i:s"
                    ></datetime>
                  </vs-col>
                </vs-row>
                <vs-row
                  v-if="this.username == 'betagrodemo' || admin == 'betagrodemo'"
                  class="mt-1 mb-2"
                  vs-w="12"
                >
                  <vs-col class="mt-4" vs-lg="12" vs-sm="12" vs-xs="12">
                    <vs-table
                      style="background: #212121"
                      :data="resultLogSensor"
                      v-if="type == 'S4' && resultLogSensor.length !== 0"
                      max-items="5"
                      pagination
                    >
                      <template slot="thead">
                        <vs-th
                          style="background: #484848; color: #ffffff"
                          sortKey="name"
                        >
                          Mac Address
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff"
                          sortKey="timestamp">
                          Timestamp
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff">
                          Unlocked
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff">
                          Uninstall
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff">
                          Battery
                        </vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          style="background: #212121; color: #ffffff"
                          :key="indextr"
                          v-for="(tr, indextr) in data"
                        >
                          <vs-td :data="data[indextr].mac">
                            {{ data[indextr].mac }}
                          </vs-td>

                          <vs-td :data="data[indextr].timestamp">
                            {{ data[indextr].timestamp | formatDatetime }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.unlocked">
                            {{ data[indextr].sensordata.unlocked }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.uninstalled">
                            {{ data[indextr].sensordata.uninstalled }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.battery">
                            {{ data[indextr].sensordata.battery }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    <vs-table
                      style="background: #212121"
                      :data="resultLogSensor"
                      v-if="type == 'S1' && resultLogSensor.length !== 0"
                      max-items="5"
                      pagination
                    >
                      <template slot="thead">
                        <vs-th
                          style="background: #484848; color: #ffffff"
                          sortKey="name"
                        >
                          Mac Address
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff" sortKey="timestamp">
                          Timestamp
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff">
                          Temperature
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff">
                          Humidity
                        </vs-th>
                        <vs-th style="background: #484848; color: #ffffff">
                          Battery
                        </vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr
                          style="background: #212121; color: #ffffff"
                          :key="indextr"
                          v-for="(tr, indextr) in data"
                        >
                          <vs-td :data="data[indextr].mac">
                            {{ data[indextr].mac }}
                          </vs-td>

                          <vs-td :data="data[indextr].timestamp">
                            {{ data[indextr].timestamp | formatDatetime }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.temperature">
                            {{ data[indextr].sensordata.temperature }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.humidity">
                            {{ data[indextr].sensordata.humidity }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.battery">
                            {{ data[indextr].sensordata.battery }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    <vs-button
                      class="bts"
                      color="success"
                      @click="getChartData()"
                      type="filled"
                      >Show</vs-button
                    >
                    <vs-button
                      class="ml-2 bts"
                      color="grey"
                      @click="clearChartData()"
                      type="filled"
                      >Clear</vs-button
                    >
                  </vs-col>
                </vs-row>
                <vs-row v-else class="mt-1 mb-2" vs-w="12">
                  <vs-col class="mt-1" vs-lg="12" vs-sm="12" vs-xs="12">
                    <vs-table
                      :data="resultLogSensor"
                      v-if="type == 'S4' && resultLogSensor.length !== 0"
                      max-items="5"
                      pagination
                    >
                      <template slot="thead">
                        <vs-th sortKey="name"> Mac Address </vs-th>
                        <vs-th sortKey="timestamp"> Timestamp </vs-th>
                        <vs-th> Unlocked </vs-th>
                        <vs-th> Uninstall </vs-th>
                        <vs-th> Battery </vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="data[indextr].mac">
                            {{ data[indextr].mac }}
                          </vs-td>

                          <vs-td :data="data[indextr].timestamp">
                            {{ data[indextr].timestamp | formatDatetime }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.unlocked">
                            {{ data[indextr].sensordata.unlocked }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.uninstalled">
                            {{ data[indextr].sensordata.uninstalled }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.battery">
                            {{ data[indextr].sensordata.battery }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    <vs-table
                      :data="resultLogSensor"
                      v-if="type == 'S1' && resultLogSensor.length !== 0"
                      max-items="5"
                      pagination
                    >
                      <template slot="thead">
                        <vs-th sortKey="name"> Mac Address </vs-th>
                        <vs-th sortKey="timestamp"> Timestamp </vs-th>
                        <vs-th> Temperature </vs-th>
                        <vs-th> Humidity </vs-th>
                        <vs-th> Battery </vs-th>
                      </template>

                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td :data="data[indextr].mac">
                            {{ data[indextr].mac }}
                          </vs-td>

                          <vs-td :data="data[indextr].timestamp">
                            {{ data[indextr].timestamp | formatDatetime }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.temperature">
                            {{ data[indextr].sensordata.temperature }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.humidity">
                            {{ data[indextr].sensordata.humidity }}
                          </vs-td>
                          <vs-td :data="data[indextr].sensordata.battery">
                            {{ data[indextr].sensordata.battery }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                    <vs-button
                      class="bts"
                      color="success"
                      @click="getChartData()"
                      type="filled"
                      >Show</vs-button
                    >
                    <vs-button
                      class="ml-2 bts"
                      color="grey"
                      @click="clearChartData()"
                      type="filled"
                      >Clear</vs-button
                    >
                  </vs-col>
                </vs-row>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import Data from "../dashboard/Sensor/Data";
import State from "../dashboard/Sensor/State";
import Control from "../dashboard/Sensor/Control";
import Lastest from "../dashboard/Sensor/Lastest";
import Aircon from "../dashboard/Sensor/Aircon.vue";
import Relay from "../dashboard/Sensor/Relay.vue";
import AddDevice from "../Page/Subpage/editSensor.vue";
import ReportChart from "../Page/IndoorTracking/components/ReportChart.vue";
import moment from "moment";

import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

export default {
  name: "SensorDashboard",
  props: ["name", "mode"],
  components: {
    Aircon,
    Relay,
    Data,
    State,
    Control,
    Lastest,
    AddDevice,
    ReportChart,
  },
  filters: {
    formatDatetime(value) {
      return moment(value).format("lll");
    },
  },
  data: () => ({
    nwid: "",
    alertlog: "",
    get_cari: [],
    nwname: "",

    username: "",
    sensorname: "",
    macname: "",
    statussensor: "",
    sensorid: "",
    gatewayid: "",
    idsensor: "",
    token: "",
    type: "",
    fan: "",
    lastact: "",
    condata: [],
    temp: 0,
    alertlistdata: [],
    alertheaderlist: [
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Alert Timestamp",
      "Status",
      "Reading Data",
    ],
    options1: ["Min", "Low", "Medium", "High", "Max", "Auto"],
    options2: ["Off", "Auto", "Cool", "Heat", "Dry", "Fan"],
    airmode: "",
    random: [],
    random2: [],
    calldata: [],
    tempCalibrate: 0,
    humidCalibrate: 0,
    count: [],
    sensdata: [{}],
    maxcount: 0,
    lora: "",
    dataTpr: [],
    dataLog: [],
    mintime: "",
    maxtime: "",
    resultLogSensor: [],
    get_cali: [],
    calibrateInterval: null,
    createInterval: true,
    admin: ""
  }),
  methods: {
    cancelModal() {
      this.$refs["modalCali"].hide();
      clearInterval(this.calibrateInterval)
      this.createInterval = true
    },
    async get_calibrate(item) {
      this.$refs["modalCali"].show();
      // let body = {
      //   senID: item,
      // };
      // console.log(body);
      console.log(item)
      this.get_cali = await this.$API.get(`calibrate/${item}`)
      this.get_cali = this.get_cali.data
      console.log(this.get_cali)
      if(this.createInterval) {
        this.tempCalibrate = this.get_cali.temp_calibrate
        this.humidCalibrate = this.get_cali.humid_calibrate
        this.calibrateInterval = setInterval(() => {
          this.get_calibrate(item)
        }, 1000);
        this.createInterval = false
      }

    },
    acceptCalibrate(item1, item2, item3) {
      console.log(item1, item2, item3);
      clearInterval(this.calibrateInterval)
      this.createInterval = true
      let body = {
        tempCalibrate: item1,
        humidCalibrate: item2,
        indoorSenID: item3,
      };
      console.log(body);
      this.$API.post(`calibrate/me`, body).then((result) => {
        console.log(result);
        if (result.status == 200) {
          this.$vs.notify({
            title: "Successful Update",
            color: "primary",
            position: "top-center",
          });
          this.$refs["modalCali"].hide();
        }
      });
    },
    clearChartData() {
      this.resultLogSensor = [];
      this.mintime = "";
      this.maxtime = "";
    },
    statechange(bool) {
      this.$API.post("updatestate/" + this.sensorid, {
        Protocol: this.calldata[0].protocol,
        Power: bool,
        Mode: this.airmode,
        Temp: this.temp,
        Fan: this.fan,
        state: true,
      });
    },
    getChartData() {
      // console.log("this.mintime", this.mintime);
      // console.log("this.maxtime", this.maxtime);
      // console.log("this.macname", this.macname);
      this.$vs.loading()
      this.$API
        .post("indoorsensorgraph", {
          mac: this.macname,
          start: this.mintime,
          end: this.maxtime,
        })
        .then((result) => {
          console.log(result.data);
          this.resultLogSensor = result.data;
          this.resultLogSensor.reverse()
          this.$vs.loading.close()
        });
    },
    Test() {
      this.State += 1;
    },
    back() {
      this.$router.push({
        name: "ViewNetwork",
        params: {
          name: this.nwname,
          id: this.nwid,
        },
      });
    },
    Max(num) {
      if (this.maxcount <= num) this.maxcount = num;
    },
    getTagLog() {
      this.dataLog = [];
      this.$API.get("indoorsensorlog/all/" + this.macname).then((result) => {
        // console.log(result.data);
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          //  console.log(obj.manhour);
          if (this.type == "S1") {
            let payload = {
              name: obj.name,
              mac: obj.mac,
              type: "S1",
              timest: moment(obj.timestamp).format("lll"),
              temp: obj.sensordata.temperature,
              humid: obj.sensordata.humidity,
              bat: obj.sensordata.battery,
            };
            this.dataLog.push(payload);
            this.lastact = moment(obj.timestamp).format("lll");
            payload = {};
            // console.log(this.dataLog);
          }
          if (this.type == "S4") {
            let payload = {
              name: obj.name,
              mac: obj.mac,
              type: "S4",
              timest: moment(obj.timestamp).format("lll"),
              uninstall: obj.sensordata.uninstalled,
              unlock: obj.sensordata.unlocked,
              bat: obj.sensordata.battery,
            };
            this.dataLog.push(payload);
            this.lastact = moment(obj.timestamp).format("lll");
            payload = {};
            // console.log(this.dataLog);
          }
        }
      });

      this.$API.get("indoorsensor/" + this.macname).then((result) => {
        console.log(result.data);
        this.get_cari = result.data;
      });
      // setTimeout(() => {
      //     this.dataLog=this.dataTpr;
      //     console.log(this.dataLog);
      //   }, 100);
    },

    exportXLSX() {
      if(this.resultLogSensor[0].sensordata.hasOwnProperty('unlocked')) {
      this.resultLogSensor.forEach((el) => {
        console.log(el.sensordata);
        el["Door Status"] = el.sensordata.unlocked == false ? 'Close' : 'Open';
        el["Install Status"] = el.sensordata.uninstalled == false ? 'Installed' : 'Uninstall';
        el["battery"] = el.sensordata.battery;
        el.timestamp = moment(el.timestamp).format('YYYY-MM-DD HH:mm:ss')
        delete el.sensordata;
        delete el.username;
      });
      }else{
      this.resultLogSensor.forEach((el) => {
        console.log(el.sensordata);
        el["temperature"] = el.sensordata.temperature;
        el["humidity"] = el.sensordata.humidity;
        el["battery"] = el.sensordata.battery;
        el.timestamp = moment(el.timestamp).format('YYYY-MM-DD HH:mm:ss')
        delete el.sensordata;
        delete el.username;
      });
      }
      const dataWS = XLSX.utils.json_to_sheet(this.resultLogSensor);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, this.sensorname + " export.xlsx");
    },

    exportPDF() {
      let pdfRef = this.$refs.pdf;
      html2canvas(pdfRef).then((canvas) => {
        let pdfImage = canvas.toDataURL();

        let pdf = new jsPDF();
        pdf.addImage(pdfImage, "PNG", 0, 20, 200, 100);
        pdf.save(this.sensorname + " export.pdf");
      });
    },
  },
beforeDestroy(){
  clearInterval(this.calibrateInterval)
},
  created() {
    this.macname = this.$session.get("macname");
    //  console.log(this.dataLog)
    this.getTagLog();
  },
  //  link3() {
  //     // this.$session.set('nwname',this.network)

  //     // this.$session.set("statussensor", item.active);
  //     // this.$session.set("nwid", item.nwid);
  //     // this.$session.set("sensorname", item.name);
  //     // this.$session.set("sensorid", item.serial_id);
  //     // this.$session.set("gatewayid", item.gatewayid);
  //     // this.$session.set("type", item.type);
  //     // this.$session.set("lora", item.lora);
  //     // this.$session.set("idsensor", this.findID(item));
  //     // console.log(this.network,item) .macname .type
  //     this.$session.set("sensorname", item.name);
  //     this.$session.set("macname", item.macname);
  //     this.$session.set("type", item.type);

  //     v-b-modal.addsensor

  //     // console.log(this.network,item)
  //     // this.$router.push({
  //     //   name: "editTag",
  //     //   params: {
  //     //     sensorname: this.name,
  //     //   },
  //     // });

  //   },
  mounted() {
    clearInterval(this.calibrateInterval)
    this.nwname = this.$session.get("nwname");
    this.nwid = this.$session.get("nwid");
    this.sensorname = this.$session.get("sensorname");
    this.macname = this.$session.get("macname");
    this.sensorid = this.$session.get("sensorid");
    this.gatewayid = this.$session.get("gatewayid");
    this.statussensor = this.$session.get("statussensor");
    this.type = this.$session.get("type");
    this.lora = this.$session.get("lora");
    this.idsensor = this.$session.get("idsensor");
    this.username = this.$session.get("username");
    this.token = this.$session.get("token");
    this.admin = this.$session.get("admin")
    switch (this.username || this.admin) {
      case "betagrodemo":
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
          testElement.style.color = "#FFFFFF";
        });
        var elemtable = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.background = "#212121";
        });
        var elemtableheader = document.getElementsByClassName("vs-list--title");
        Array.prototype.filter.call(
          elemtableheader,
          function (testElementtableheader) {
            testElementtableheader.style.background = "#212121";
            testElementtableheader.style.color = "#FFFFFF";
          }
        );
        var elemtableul = document.getElementsByClassName("vs-pagination--nav");
        Array.prototype.filter.call(elemtableul, function (testElementtableul) {
          testElementtableul.style.background = "none";
        });
        document.getElementById("myDiv").style.paddingBottom = "500px";
        // var elemtableul = document.getElementsByClassName("a");
        // Array.prototype.filter.call(elemtableul, function (testElementtableul) {
        //   testElementtableul.stylestyle.color = "#FFFFFF";
        // });
        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
  computed: {
    calibrationhumid() {
      return (
        parseInt(this.get_cali.humid_calibrate) + parseInt(this.get_cali.humid)
      );
    },
    calibrationTemp() {
      return (
        parseInt(this.get_cali.temp_calibrate) + parseInt(this.get_cali.temp)
      );
    },
  },
};
</script>
<style scoped>
.btnBorderpop {
  border-radius: 20px;
  width: 80px;
}
.cssTable {
  border-radius: 20px;
  background-color: #f2f3f4;
}
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
img {
  max-width: 100%;
  height: auto;
}

.textRight {
  text-align: right;
}
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
.bts {
  width: 70px;
  border-radius: 18px;
}
.vdatetime-popup__header {
  padding: 18px 30px;
  background: #00bd45;
  color: #fff;
  font-size: 32px;
}
.vdatetime-popup__actions__button {
  display: inline-block;
  border: none;
  padding: 10px 20px;
  background: transparent;
  font-size: 16px;
  color: #00bd45;
  cursor: pointer;
  transition: color 0.3s;
}
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  color: #fff;
  background: #00bd45;
}
.vdatetime-time-picker__item--selected {
  color: #00bd45;
  font-size: 32px;
}
.vdatetime-year-picker__item--selected {
  color: #00bd45;
  font-size: 32px;
}
.vdatetime-month-picker__item--selected {
  color: #00bd45;
  font-size: 32px;
}
</style>
